import React from 'react'
import { Link, Stack, Typography } from '@mui/material'
import ModalHeader from '../ModalHeader'
import styled from '@emotion/styled'
import { ArticleType } from 'types'

const StyledLink = styled(Link)`
  cursor: pointer;
`

interface Props {
  handleClose: () => void
  retakeQuiz: () => void
  name: string
  notificationText?: string | null
  learnArticleId?: number | null
  learnArticleName?: string | null
  careArticleId?: number | null
  careArticleName?: string | null
  onArticleClick: (type: ArticleType, id: number) => void
}

const Paragraph = styled.p`
  margin-top: 0;
  margin-bottom: 10px;
`

const defaultResultText = `The Memory Care Partner App will provide more information about memory loss via short
  personalized articles in the Care Center as well as a reference articles in the Learn
  Library. Additionally, you should follow up with a medical care provider to evaluate your
  concerns and determine potential causes for any memory loss signs.`

const FinalScreen = (props: Props) => {
  const {
    handleClose,
    notificationText,
    learnArticleId,
    learnArticleName,
    careArticleId,
    careArticleName,
    onArticleClick,
  } = props
  const resultText = notificationText || defaultResultText

  return (
    <Stack spacing={2}>
      <ModalHeader handleClose={handleClose}>
        <Typography fontWeight={400} variant="h5">
          Results panel
        </Typography>
      </ModalHeader>

      <Typography>
        <Paragraph>{resultText}</Paragraph>
      </Typography>

      {(!!learnArticleId || !!careArticleId) && (
        <Stack gap={1}>
          {!!learnArticleId && (
            <StyledLink onClick={() => onArticleClick(ArticleType.LearnLibrary, learnArticleId)}>
              {learnArticleName || 'Learn More'}
            </StyledLink>
          )}
          {!!careArticleId && (
            <StyledLink onClick={() => onArticleClick(ArticleType.CareArticle, careArticleId)}>
              {careArticleName || 'Action Post'}
            </StyledLink>
          )}
        </Stack>
      )}
    </Stack>
  )
}

export default FinalScreen
